import React from 'react';

import useGlobalStyle from '@/hooks/use-global-style';
import type { GlobalStyleProps } from '@/utils/global-style/typings';
import { Global } from '@emotion/react';

const GlobalStyle: React.FC<GlobalStyleProps> = ({ theme }) => {
	const globalStyle = useGlobalStyle(theme);

	return <Global styles={globalStyle} />;
};

export default GlobalStyle;
